import { render, staticRenderFns } from "./AudioFileEditForm.vue?vue&type=template&id=ac1266f2"
import script from "./AudioFileEditForm.vue?vue&type=script&lang=js"
export * from "./AudioFileEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports